import clone from 'clone';

const defaultDesign = {
  logo: false,
  favicon: false,
  colors: {
    // Default colors (colors that probably shouldn't be changed at all)
    white: '#ffffff',
    black: '#000000',
    'color-background-light': '#e6e6e6',
    'color-input-border': '#afafaf',
    'color-input-border-text': '#464a4c',
    'color-input-border-focus': '#231f20',
    'color-text-light': '#9b9b9b',
    'color-inactive': '#e6e6e6',
    'color-error': '#d8000c',
    'color-light': '#f5f5f5',
    'color-diagram': '#8cbc41',
    'color-guarantied-number': '#84BD00',
    'color-interests-inactive-icon': '#000000',
    'color-recommendation-marketing-goal': '#47b383',
    'color-recommendation-suggested-goal': '#47b383',
    'color-btn-recommendation-other': '#47b383',

    // Colors that inherits something - TODO - load from style.scss
    'color-btn-start': '',
    'color-btn-confirm': '',
    'color-btn-login': '',
    'color-btn-logout': '',
    'color-btn-group-actions': '',
    'color-top-navigation': '',
    'color-top-navigation-disabled': '',
    'color-active-switches': '',
    'color-step-title-background': '',
    'color-pie-controls': '',

    // GotU default design
    'color-primary': '#47b383',
    'color-secondary': '#2e4056',
    'color-target-bottom': '#fac32f',
    'color-background-header': '#ffffff',
  },
};

const allDesigns = {
  default: {
    logo: false,
    colors: {},
  },
};

export function getDefaultDesign() {
  return defaultDesign;
}

export function getAllDesigns() {
  return clone(allDesigns);
}

export function mergeDesigns(design) {
  const compiled = {
    colors: Object.assign({}, defaultDesign.colors, design.colors || {}),
    logo: design.logo || defaultDesign.logo,
    favicon: design.favicon || defaultDesign.favicon,
  };
  return compiled;
}



// WEBPACK FOOTER //
// ./src/components/initializer/static-design.js